<template>
  <div id="app" style="height: 100%;" v-bind:class="{ 'background' : !isAuthorized && !docIsShown }">
    <span v-if="docIsShown">
      <router-view class="view"></router-view>
    </span>
    <span v-else>
      <div v-bind:class="{ 'contest-header-container' : isContestAuthorized, 'header-container' : !isContestAuthorized }" v-if="isAuthorized">
        <transition appear name="slide-fade" mode="out-in">
          <span>
            <span v-if="isContestAuthorized">
              <contestheader></contestheader>
            </span>
            <span v-else>
              <appheader></appheader>
            </span>
          </span>
        </transition>
      </div>
      <div id="content-container" v-bind:class="{ 'contest-content-container' : isContestAuthorized, 'content-container' : !isContestAuthorized }">
        <el-col :span="4" class="sidebar-container" v-if="isAuthorized && !isContestAuthorized">
          <transition appear name="slide-fade" mode="out-in">
            <sidebar></sidebar>
          </transition>
        </el-col>
        <el-col :span="isContestAuthorized ? 24 : 20" style="height:100%;">
          <transition appear name="slide-fade" mode="out-in">
            <router-view class="view"></router-view>
          </transition>
        </el-col>
      </div>
      <div v-bind:class="{ 'contest-footer-container' : isContestAuthorized, 'footer-container' : !isContestAuthorized }" v-if="isAuthorized">
        <transition appear name="slide-fade" mode="out-in">
          <span>
            <span v-if="isContestAuthorized">
              <contestfooter></contestfooter>
            </span>
            <span v-else>
              <appfooter></appfooter>
            </span>
          </span>
        </transition>
      </div>
    </span>
  </div>
</template>

<script>
  import config from './appsettings.js'
  import appheader from './components/layout/appheader'
  import appfooter from './components/layout/appfooter'
  import sidebar from './components/layout/sidebar'
  import contestfooter from './components/contest/footer'
  import contestheader from './components/contest/header'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: '',
    data() {
      return {
        isAuthorized: false,
        docIsShown: false
      }
    },
    components: {
      appheader,
      appfooter,
      sidebar,
      contestfooter,
      contestheader,
    },
    methods: {
      showDoc() {
        this.docIsShown = true;
      },
      closeDoc() {
        this.docIsShown = false;
      },
      ...mapActions([

      ])
    },
    computed: {
      loading: function() {
        return this.isContestAuthorized && this.isAwaitingNext;
      },
      ...mapGetters([
        'isContestAuthorized',
        'isAwaitingNext'
      ])
    },
    created() {
      this.$manager.getUser().then(user => {
        if (user) {
          let access_token = user.access_token;
          let options = {headers: {'Authorization': `Bearer  ${access_token}`}};
          // TEST CONNECTION TO API TO CHECK IF ACCESS_TOKEN IS OKAY
          this.$http.get(`${config.API_PREFIX}ping/auth`, options)
            .then(res => this.isAuthorized = true)
            .catch(err => {
              if (err.status === 401) this.isAuthorized = false;
              this.$gf.checkError(err);
            })
          this.isAuthorized = true;
        } else {
          this.isAuthorized = false;
        }
      });
      Event.$on('onDocIsShown', () => this.showDoc());
      Event.$on('onDocIsClosed', () => this.closeDoc());
    },
    beforeDestroy() {
      Event.$off('onDocIsShown');
      Event.$off('onDocIsClosed');
    }
  }
</script>

<style lang="scss">
  @import './assets/styles.scss';
</style>
<style lang="css">
  @import './assets/icons.css';
</style>

<style>
   html {
     overflow-y: hidden !important;
   }
   .el-table__footer td {
     font-weight: bold !important;
     background-color: #eef1f6 !important;
   }
  .default-header-color {
      background: #eef1f6 !important;
  }
   /*.el-table td,
   .el-table th.is-leaf,
   .el-table__header-wrapper {
     border-bottom: 1px solid #324157 !important;
   }
   .el-table--border td,
   .el-table--border th {
     border-right: 1px solid #324157 !important;
   }
   .el-table__footer-wrapper {
     border-top: 1px solid #324157 !important;
   }
   .el-table {
     border: 1px solid #324157 !important;
   }*/
</style>

<style scoped>
  .content-container {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 60px;
    bottom: 40px;
  }

  .header-container {
    height: 60px;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
  }

  .footer-container {
    height: 40px;
    padding: 10px;
    position: absolute;
    background-color: #f4f5f7;
    left: 0px;
    right: 0px;
    bottom: 0px;
    border-top: 1px solid #d1dbe5;
  }

  .contest-content-container {
    background-color: #eef1f6;
    position: absolute;
    padding: 0px 20px 0px 20px;
    top: 50px;
    left: 0px;
    right: 0px;
    bottom: 65px;
    overflow-y: scroll;
  }

  .contest-header-container {
    height: 50px;
    background-color: #324157;
    padding: 10px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
  }

  .contest-footer-container {
    height: 65px;
    background-color: #324157;
    padding: 10px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }

 .sidebar-container {
   background-color: #eef1f6;
   height: 100%;
   border-right: 1px solid #d1dbe5;
 }

 .background {
   /* The image used */
   background-image: url("./assets/home-background-compressed.png");
   /* Full height */
   height: 100%;
   /* Center and scale the image nicely */
   background-position: center;
   background-repeat: no-repeat;
   background-size: cover;
 }
</style>



// WEBPACK FOOTER //
// src/App.vue